export default "__VITE_ASSET__CXT6hC$I__"